<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-none d-md-block font-weight-bold">
      <!-- <p>Hand-crafted &amp; Made with</p> -->
      <feather-icon
        icon="GlobeIcon"
        size="21"
        class="text-primary stroke-current"
      />
      Your current IP :
      {{ $store.state.app.user.current_ip }}
    </span>
    <span class="float-md-right d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="https://valuementor.com/" target="_blank"
        >ValueMentor</b-link
      >
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  components: {
    BLink,
  },
};
</script>
